module.exports = __webpack_public_path__ + "img/email.b5940a96.png";